import { ped } from '../Erectile Dysfunction/Initial/flow';
import { peFollowup } from './followup/flow';
import { pe, peBeluga } from './initial/flow';
import { peBelugaMonthly } from './monthly/flow';


const PEFlows = { peBeluga, peBelugaMonthly, pe, ped, peFollowup };

export default PEFlows;
